import axios from "axios";
import { toast } from "react-toastify";

import AuthService from "../../services/auth.service";

const APP_URL = process.env.APP_URL;

export function applyVoucher({
  subscriptionPackage,
  code,
  isLoading,
  isCheckingVoucher,
  setButtonStatus,
  setIsLoading,
  setIsCheckingVoucher,
  setVoucherAccept,
  setMessageClass,
  setMessage,
  setMessageType,
  setButtonContent,
  setSubscriptionPackageFinalPrice,
  setSubscriptionPackageFinalPriceText,
  setTrialDays,
  navigate,
}) {
  if (!code || code.length < 2) {
    return false;
  }

  if (isLoading && isCheckingVoucher) {
    return false;
  }

  if (!subscriptionPackage || subscriptionPackage < 0) {
    toast.error("لطفا برنامه مورد نظر خود را انتخاب نمایید!", {
      position: "top-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "light",
    });

    return false;
  }

  setButtonStatus(false);
  setIsCheckingVoucher(true);
  setIsLoading(true);

  const config = {
    headers: { Authorization: `Bearer ${AuthService.getAccessToken()}` },
  };

  let body = {
    code: code,
    source: 2,
  };

  body = { ...body };

  axios
    .post(
      `${APP_URL}/api/v6/vouchers/check/` + subscriptionPackage.id,
      body,
      config
    )
    .then(function (response) {
      setVoucherAccept(false);
      if (response.data.message) {
        setMessageClass("success");
        setMessage(response.data.message);
        setMessageType("code-group-success");
        setButtonContent("حذف");
        setVoucherAccept(true);
        setSubscriptionPackageFinalPrice(response.data.data.final_price);
        setSubscriptionPackageFinalPriceText(
          response.data.data.final_price_text
        );
      } else {
        setSubscriptionPackageFinalPrice(subscriptionPackage.final_price);
        setSubscriptionPackageFinalPriceText(
          subscriptionPackage.final_price_text
        );
      }

      if (
        response.data.data &&
        response.data.data.trial_days &&
        response.data.data.trial_days > 0
      ) {
        setTrialDays(response.data.data.trial_days);
      } else {
        setTrialDays(null);
      }

      setIsCheckingVoucher(false);
      setIsLoading(false);
    })
    .catch(function (error) {
      setIsLoading(false);
      setIsCheckingVoucher(false);
      setVoucherAccept(false);
      if (!error.response) {
        toast.error("خطایی رخ داده است!", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        });

        return false;
      }

      const statusCode = error.response.status;
      switch (statusCode) {
        case 422:
          setMessageClass("error");
          setMessage(error.response.data.errors.code);
          setMessageType("code-group-error");
          setButtonContent("close");
          break;

        case 400:
          setMessageClass("error");
          setMessage(error.response.data.message);
          setMessageType("code-group-error");
          setButtonContent("close");
          break;

        case 401:
          navigate("/auth");
          break;
        default:
          break;
      }
    });
}
